import React, { useEffect, useState } from 'react';
import { MdVpnKey, MdAccountTree, MdSpeed, MdSettings } from 'react-icons/md';
import { AiFillInstagram } from 'react-icons/ai';
import { ReactComponent as ZapierIcon } from '../../../../assets/icons/leftMenuIcons/zapier.svg';
import { ReactComponent as MakeIcon } from '../../../../assets/icons/leftMenuIcons/make.svg';
import { ReactComponent as BookIcon } from '../../../../assets/icons/leftMenuIcons/book.svg';
import { Divider } from 'antd';
import Collapsable from './Collapsable';
import { Permissions } from '@whatsper/texterchat-common';
import { getConfig } from '../../../../settings';
import { useStore } from '../../../../store/rootStore';
import s from './Collapsable/Collapsable.module.scss';
const staticRoutes = [
    {
        titleKey: 'apiTokensManager',
        icon: React.createElement(MdVpnKey, null),
        path: '/manage/developers/api-tokens',
        requiredPermissions: [Permissions.Permission.api_tokens_view],
    },
    {
        titleKey: 'apiDocumentation',
        icon: React.createElement(BookIcon, null),
        url: 'https://apidocs.texterchat.com/',
    },
    {
        titleKey: 'oauthManager',
        icon: React.createElement(MdAccountTree, null),
        path: '/manage/developers/oauth',
        requiredPermissions: [Permissions.Permission.oauth_manage_all],
    },
    {
        titleKey: 'connectionSpeed',
        icon: React.createElement(MdSpeed, null),
        path: '/manage/developers/connection-speed',
    },
    {
        titleKey: 'panelZapier',
        icon: React.createElement(ZapierIcon, null),
        url: 'https://zapier.com/apps/texter/integrations',
    },
    {
        titleKey: 'panelMake',
        icon: React.createElement(MakeIcon, null),
        url: 'https://www.make.com/en/integrations/texter',
    },
];
const DevelopersSettings = ({ goToAppPath }) => {
    const { agentsStore } = useStore();
    const [inboxConfig, setInboxConfig] = useState(null);
    useEffect(() => {
        getConfig()
            .then((config) => {
            setInboxConfig(config);
        })
            .catch((error) => {
            console.error('Error getting inbox config', error);
        });
    }, []);
    let routes = staticRoutes
        .filter(route => {
        if (!route.requiredPermissions)
            return true;
        return agentsStore.hasPermissions(route.requiredPermissions);
    });
    if (inboxConfig === null || inboxConfig === void 0 ? void 0 : inboxConfig.instagramBusinessLogin) {
        const queryParams = new URLSearchParams();
        queryParams.set('state', btoa(JSON.stringify({ projectId: inboxConfig.projectId })));
        queryParams.set('enable_fb_login', '1');
        queryParams.set('force_authentication', '1');
        queryParams.set('response_type', 'code');
        queryParams.set('redirect_uri', inboxConfig.instagramBusinessLogin.redirectUrl);
        queryParams.set('client_id', inboxConfig.instagramBusinessLogin.clientId);
        queryParams.set('scope', 'instagram_business_basic instagram_business_manage_messages instagram_business_manage_comments');
        const url = `https://www.instagram.com/oauth/authorize?${queryParams.toString()}`;
        console.debug('Instagram login URL:', url);
        routes.unshift({
            titleKey: 'panelConnectInstagram',
            icon: React.createElement(AiFillInstagram, null),
            url,
            target: '_self',
            windowFeatures: false,
            requiredPermissions: [Permissions.Permission.channels_manage],
        });
    }
    if (routes.length === 0) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Divider, { className: s.divider }),
        React.createElement(Collapsable, { title: "panelDevelopers", icon: React.createElement(MdSettings, null), routes: routes, goToAppPath: goToAppPath })));
};
export default DevelopersSettings;
